import React, { useState } from 'react';
import { connect } from 'react-redux';

import { MODAL, modalEnumTransKey } from '../enums';

import { Container } from '../styles';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import CheckboxControl from '../../../../Tracking/components/NFFilters/components/CheckboxControl';

const label = Object.values(MODAL);

const Modal = ({ isOpen, onClick, onApply, modal }) => {
  const [selectedItem, setSelectedItem] = useState(modal);
  
  const handleChange = e => {
    const { value } = e.target;
    setSelectedItem(value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem('');
    onApply('');
  };

  return (
    <FilterContainer label="Modal" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por modal"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              checked={selectedItem === filter.toString()}
              label={modalEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => ({
  modal: state.carbon.filters.modal,
});

export default connect(mapStateToProps)(Modal);
